import { render, staticRenderFns } from "./SegmentBuilder.vue?vue&type=template&id=2a0644b4&"
import script from "./SegmentBuilder.vue?vue&type=script&lang=ts&"
export * from "./SegmentBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports